import { create } from 'zustand';
import { GroupMemberContentMode } from '../enum/EnumRepository';

interface GroupMemberContentModeState {
  groupMemberContentMode: GroupMemberContentMode;
  setGroupMemberContentMode: (mode: GroupMemberContentMode) => void;
}

export const useGroupMemberContentModeStore = create<GroupMemberContentModeState>((set) => ({
  groupMemberContentMode: GroupMemberContentMode.Orig,
  setGroupMemberContentMode: (mode) => set({ groupMemberContentMode: mode }),
}));
